import { lazy, Suspense } from "react";
import { Route } from "react-router";

import { PageLayout } from "@/shared/components";

import { PageLoading } from "./PageStatus";

// The pages, and through them the chart libraries (vega, vega-lite, d3), the
// Arrow table code, and the rest of the feature, are fetched the first time a
// boards route renders rather than on every page of the app.
const BoardList = lazy(() =>
  import("./BoardList/BoardList").then((module) => ({
    default: module.BoardList,
  })),
);
const BoardPage = lazy(() =>
  import("./BoardPage/BoardPage").then((module) => ({
    default: module.BoardPage,
  })),
);

/**
 * Stands in for a boards page while its chunk downloads: a header titled
 * Boards over the spinner the page then shows while its board or its list is
 * on the way, so the spinner stays in place when the chunk arrives. The
 * page's own header content, such as the list's Import and New board buttons
 * or a board's breadcrumbs, appears with the page. PageLayout renders the
 * `<main>` that `.app-layout > main` gives the row's free width (`flex: 1`),
 * so the collaboration bar stays at the right edge of the row while the chunk
 * downloads.
 */
function BoardsLoading() {
  return (
    <PageLayout title="Roboto - Boards" headerContentLeft="Boards">
      <PageLoading label="Loading boards" />
    </PageLayout>
  );
}

/**
 * Child routes for the boards feature, returned as an array the central router
 * spreads under `/boards`, so the data router registers each path.
 */
export const BoardsRoutes = () => [
  <Route
    key="index"
    index
    element={
      <Suspense fallback={<BoardsLoading />}>
        <BoardList />
      </Suspense>
    }
  />,
  <Route
    key="board"
    path=":boardId"
    element={
      <Suspense fallback={<BoardsLoading />}>
        <BoardPage />
      </Suspense>
    }
  />,
];
